import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { IPageDataOffer } from '@ucheba/store/page-data/offer/types'
import { useRouter } from 'next/router'
import TariffsBlock from '../../../../../components/Blocks/TariffsBlock/desktop'
import TimerBanner from '../../../../../components/Blocks/TimerBanner/desktop'
import { ETypeRequest } from '../types'
import { EApplicationFunnels } from '../../../../../components/AppliactionForm/types'
import { ISchoolPageProps } from '../../../school/index/types'
import { useGetMaxDiscountByTariffs } from '../../../../../components/Blocks/TariffsBlock/bll/useGetMaxDiscountByTariffs'
import { useSelectProductRequestApplication } from '../../../../../components/SelectProductRequestApplication/bll'

const Block = styled.div`
  background-color: ${sv.color.navy};
  color: white;
  padding: 120px 0 20px 0;
`

const TimerBlock = styled.div`
  margin: auto;
  width: 992px;
  padding: 4px;
`

const IndexEgeTariffsPage: FC<
  ISchoolPageProps['content']['tariffs'] & { timer: IPageDataOffer }
> = (props) => {
  const { title, products, children, timer } = props

  const { selectGroup } = useSelectProductRequestApplication({})

  const handleRequestClick = (productId?: number, count?: number): void => {
    const typeRequest = ETypeRequest.ege_lead_request

    const data: any = {}

    if (count) {
      data.count = count
    }

    if (productId) {
      data.productId = productId
    }

    selectGroup(EApplicationFunnels.course_booking, typeRequest, data)
  }

  const handleRequestBannerClick = (amoTag?: string): void => {
    const requestTarget = ETypeRequest.oge_lead_request

    selectGroup(
      EApplicationFunnels.course_booking,
      requestTarget,
      undefined,
      undefined,
      amoTag
    )
  }

  const { pathname } = useRouter()

  const classValue = useMemo(() => {
    if (pathname.includes('ege-10')) {
      return '10'
    }

    return '11'
  }, [pathname])

  const totalDiscount = useGetMaxDiscountByTariffs(classValue)

  const titleStatic = useMemo(() => {
    return `Успейте присоединиться к&nbsp;новому потоку</br> со <span  class="highlight">скидкой до&nbsp;${totalDiscount}%</span>`
  }, [totalDiscount])

  return (
    <Block>
      <Container>
        <TariffsBlock
          title={title.desktop || titleStatic}
          products={products}
          onClick={handleRequestClick}
          initialClass={classValue}
          requestTarget={ETypeRequest.ege_lead_request}
        />

        {timer && !timer.hidden && (
          <TimerBlock>
            <TimerBanner
              title={timer?.card?.title?.desktop}
              date={timer.endDate}
              onClick={handleRequestBannerClick}
              color='gold'
              buttonColor='orange'
              buttonText={timer?.card?.buttonText?.desktop}
            />
          </TimerBlock>
        )}

        <Spacing spacing='uxlarge' />

        {children}
      </Container>
    </Block>
  )
}

export default IndexEgeTariffsPage
